import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/bank-transactions")(
  {
    staticData: {
      breadcrumb: "Bank Transactions",
    },
    component: () => <Outlet />,
  },
);
